export const POSITION_STATIC: 'static' = 'static'
export const POSITION_RELATIVE: 'relative' = 'relative'
export const POSITION_ABSOLUTE: 'absolute' = 'absolute'
export const POSITION_FIXED: 'fixed' = 'fixed'
export const POSITION_STICKY: 'sticky' = 'sticky'
